import { UserLoginResponseModel, UserResultModel } from "../../swagger-clients/s365-admin-panel-clients.service";
import { ApplicationTypes, ISetUserNameAction } from "./application.types";


export const setUser = (user: UserLoginResponseModel) => ({
    type: ApplicationTypes.SET_USER,
    user: user
} as ISetUserNameAction)